export default function () {
  const widgetName = 'cardseight';
  const widgetOpts = cardseightOpts;
  const windowSize = $(window).width();
  const breakpoint = 800;

  const buildCardStructure = (dataWidget) => `
      <div class="img-background lozad" style="background-image: url('${dataWidget.ImageWithPath}')">
        <div class="overlay"></div>
        <div class="card-content">
          <span class="widget-title">${dataWidget.Title}</span>
          <div class="overlay-content">
            ${dataWidget.Description ? `<span class="widget-description">${dataWidget.Description}</span>` : ''}
            <div class="buttons-containers">
              ${dataWidget.URL ? `<a class="button" href="${dataWidget.URL}">More</a>` : ''}
              ${dataWidget.PurchaseURL ? `<a class="button" href="${dataWidget.PurchaseURL}">Buy Now</a>` : ''}
            </div>
          </div>
        </div>
      </div>
    `;

  const configureCardLink = ($card, dataWidget) => {
    const isMobileView = windowSize <= breakpoint;

    if (!dataWidget.URL && !dataWidget.PurchaseURL && !dataWidget.Description) {
      $card.addClass('void-link').removeAttr('href');
    } else {
      $card.removeClass('void-link').removeAttr('target');
    }

    if (isMobileView) {
      if (dataWidget.PurchaseURL && !dataWidget.URL) {
        $card.attr('href', dataWidget.PurchaseURL).removeClass('void-link');
      } else if (!dataWidget.URL && !dataWidget.PurchaseURL) {
        $card.removeAttr('href');
      }
    }
  };

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    link: windowSize < breakpoint ? ['all'] : [''],
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    lazyLoadImages: true,
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;

      if (widgetCount === 0) {
        $(`#${widgetName}`).remove();
        return;
      }

      $(`#${widgetName} .card-widget-item`).each((index, element) => {
        const $card = $(element);

        const dataWidget = data.items[index];
        $card.empty().append(buildCardStructure(dataWidget));
        configureCardLink($card, dataWidget);
      });
    },
  });
}
